import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedComponentsModule } from '../../core/shared-components.module';
import { BasicModalComponent } from './components/basic-modal/basic-modal.component';
import { MultiStepModalComponent } from './components/multi-step-modal/multi-step-modal.component';

import { FnaRoutingModule } from './fna-routing.module';
import { AccreditedInvestorOptInComponent } from './pages/accredited-investor-opt-in/accredited-investor-opt-in.component';
import { AccreditedInvestorComponent } from './pages/accredited-investor/accredited-investor.component';
import { ConfirmationComponent } from './pages/confirmation/confirmation.component';
import { FinancialSituationComponent } from './pages/financial-situation/financial-situation.component';
import { NonRecommendedProductsComponent } from './pages/non-recommended-products/non-recommended-products.component';
import { OrganizationInformationComponent } from './pages/organization-information/organization-information.component';
import { RecommendedProductsComponent } from './pages/recommended-products/recommended-products.component';
import { ReviewAndSubmitComponent } from './pages/review-and-submit/review-and-submit.component';
import { RiskAndObjectivesComponent } from './pages/risk-and-objectives/risk-and-objectives.component';
import { RiskProfileAssessmentComponent } from './pages/risk-profile-assessment/risk-profile-assessment.component';
import { AccreditedInvestorConfirmationComponent } from './pages/accredited-investor-confirmation/accredited-investor-confirmation.component';
import { ConfirmationLoadingComponent } from './pages/confirmation-loading/confirmation-loading.component';

@NgModule({
  declarations: [
    AccreditedInvestorComponent,
    OrganizationInformationComponent,
    FinancialSituationComponent,
    RiskAndObjectivesComponent,
    RiskProfileAssessmentComponent,
    RecommendedProductsComponent,
    NonRecommendedProductsComponent,
    ReviewAndSubmitComponent,
    ConfirmationComponent,
    AccreditedInvestorOptInComponent,
    MultiStepModalComponent,
    BasicModalComponent,
    AccreditedInvestorConfirmationComponent,
    ConfirmationLoadingComponent,
  ],
  imports: [
    CommonModule,
    FnaRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    SharedComponentsModule,
    NgbModule,
  ],
})
export class FnaModule {}
